import { registryApi } from '../clients/AxiosClients'
import i18n from '../../VueI18n'

/**
 * Retorna todos os talhoes cadastradas no banco de dados
 */
const getAllTalhoes = async () => {
	return registryApi.get('v2/Talhao')
}

/**
 * Retorna todos os talhões cadastradas no banco de dados com paginação
 * @param {number} PagNumber - Número da página
 * @param {number} PagSize - Tamanho da página
 * @param {string} FilteringWord - Palavra chave busca  */

const getAllTalhoesPagination = async (PagNumber, PagSize, FilteringWord) => {
	return registryApi.post('v2/Talhao/GetToCrudTable', { PagNumber, PagSize, FilteringWord })
}

/**
 * Retorna todos os talhoes estruturadas para o componente de DropdownFk
 */
const getDropdownTalhoes = async () => {
	const result = await registryApi.get('v2/Talhao/lista-dropdown')
	return result.data.map((talhao) => {
		return {
			id: talhao.id,
			[i18n.t('code')]: talhao.tlho_cd_codigo,
			[i18n.t('description')]: talhao.tlho_ds_descricao,
			[i18n.t('farm')]: talhao.fzda_nm_nome,
			[i18n.t('acronym')]: talhao.tpsl_nm_sigla,
		}
	})
}

/**
 * Cadastrar nova fazenda no banco de dados
 * @param {Object} body talhão que será cadastrada
 */
const createTalhao = async (body) => {
	return registryApi.post('v2/Talhao', body)
}

/**
 * Atualiza talhão no banco de dados
 * @param {Object} body talhão que será atualizada
 */
const updateTalhao = async (body) => {
	return registryApi.put('v2/Talhao', body)
}

/**
 * Lista dos ids de talhão que devem ser excluidos do banco de dados
 * nome do parametro deve ser data pois método DELETE do axios obrigatoriamente recebe um argumento 'data'
 * @param {Array} data Lista dos ids de talhão
 */
const deleteTalhaoByIdList = async (data) => {
	return registryApi.delete('v2/Talhao/exclui-todos-por-lista-ids', { data })
}

export {
	getAllTalhoes,
	getDropdownTalhoes,
	createTalhao,
	updateTalhao,
	deleteTalhaoByIdList,
	getAllTalhoesPagination,
}
